import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_29: FaireProductEntity = {
  token: "starter_collection_29",
  type: "product",
  name: "Paprika Oven Mitts",
  brandName: "Hedley & Bennett",
  imageUrl: "",
  priceDollars: 65,
  msrpDollars: 130,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
